import React from "react";
import Cookies from "universal-cookie";
import dayjs from "dayjs";
import { CSVLink } from "react-csv";

import withAuth from "../../hoc/withAuth";
import MainLayout from "../../components/layouts/MainLayout";

import { otodisService } from "../../services/OtodisService";

import { Form, DatePicker, Input, Table, Button, Modal, Row, Col, Space, Tooltip, Select, Switch } from "antd";
import { SearchOutlined, ExportOutlined, CopyOutlined } from "@ant-design/icons";

import SelectDealer from "../../components/selects/SelectDealer";
import ModalDetailBBN from "../../components/modal/ModalDetailBBN";
import ModalPaymentProgressive from "../../components/modal/ModalPaymentProgressive";
import SelectStatusProgressive from "../../components/selects/SelectStatusProgressive";

class MonitoringProgressive extends React.Component {
  token = new Cookies().get("_bbn_tn");
  tableColumn = [
    {
      title: "Aksi",
      key: "aksi",
      width: 100,
      // align: "center",
      render: (value, row) => {
        const ownership_order = row?.vehicle_notice_data?.ownership_order || 0;
        const pkb = Number(row?.vehicle_notice_data?.pkb) || 0;
        const isPaid = row?.progressive_payment_status === "PAID";

        const shouldShowProgressive = ownership_order > 1 && pkb > 0;

        if (!shouldShowProgressive) return null;

        return (
          <div
            onClick={(event) => this.showModalProgressive(row)}
            style={{
              display: "inline-block",
              padding: "2px 6px",
              fontSize: "90%",
              backgroundColor: "#fff1f0",
              color: "#cf1322",
              border: "1px solid #ffa39e",
              borderRadius: "4px",
              cursor: "pointer",
              marginTop: 4,
            }}
          >
            {isPaid ? "Lihat Progresif" : "Bayar Progresif"}
          </div>
        );
      },
    },
    {
      title: "Kode Order",
      dataIndex: "order_code",
      key: "order_code",
      width: 220,
      ellipsis: true,
      render: (value, row) => {
        return (
          <React.Fragment>
            <span className={`font-90-link`} onClick={(event) => this.showDetail(row)}>
              {value}
              &nbsp;
              <Tooltip title="Click untuk copy kode order" color={"cyan"}>
                <CopyOutlined className={"small-avatar-link"} onClick={(event) => this.copyToClipboard(value)} />
              </Tooltip>
            </span>
          </React.Fragment>
        );
      },
    },
    {
      title: "Nama Konsumen",
      dataIndex: "customer_doc_name",
      key: "customer_doc_name",
      width: 120,
    },
    {
      title: "Tgl Penugasan",
      dataIndex: "create_date",
      key: "create_date",
      width: 100,
    },
    {
      title: "Usia",
      dataIndex: "create_date",
      key: "usia_order",
      width: 80,
      ellipsis: true,
      render: (value) => {
        const usia = dayjs().diff(dayjs(value), "days");
        return `${usia} hari`;
      },
      sorter: (a, b) => {
        const usiaA = dayjs().diff(dayjs(a.create_date), "days");
        const usiaB = dayjs().diff(dayjs(b.create_date), "days");
        return usiaA - usiaB;
      },
    },
    {
      title: "No Mesin",
      dataIndex: "vehicle_engine_number",
      key: "vehicle_engine_number",
      width: 110,
      ellipsis: true,
      render: (value, row) => {
        return (
          <React.Fragment>
            <span>
              {value}
              &nbsp;
              <Tooltip title="Click untuk copy kode order" color={"cyan"}>
                <CopyOutlined className={"small-avatar-link"} onClick={(event) => this.copyToClipboard(value)} />
              </Tooltip>
            </span>
          </React.Fragment>
        );
      },
    },
    {
      title: "Variant Kendaraan",
      dataIndex: "vehicle_variant_name",
      key: "vehicle_variant_name",
      width: 120,
    },
    {
      title: "Marketing",
      dataIndex: "marketing_name",
      key: "marketing_name",
      width: 120,
    },

    {
      title: "Notice Uploaded",
      dataIndex: "vehicle_notice_data",
      key: "notice_uploaded",
      width: 80,
      render: (value) => {
        if (!value) return "";
        return value.jumlah ? "TRUE" : "FALSE";
      },
    },
    {
      title: "Notice Approved",
      dataIndex: "payment_approved",
      key: "payment_approved",
      width: 80,
    },
    {
      title: "Kepemilikan",
      dataIndex: "vehicle_notice_data",
      key: "ownership_order",
      width: 80,
      ellipsis: true,
      render: (value) => {
        if (!value) return "";
        return Number(value.ownership_order) || 1;
      },
    },
    {
      title: "PKB Notice",
      dataIndex: "vehicle_notice_data",
      key: "total_pkb",
      width: 80,
      ellipsis: true,
      render: (value) => {
        const number = Number(value.pkb);
        return !isNaN(number) ? number.toLocaleString() : "0";
      },
    },
    {
      title: "Biaya Progresif",
      dataIndex: "progressive_cost",
      key: "progressive_cost",
      width: 100,
      ellipsis: true,
      render: (value) => {
        const number = Number(value);
        return !isNaN(number) ? number.toLocaleString() : "0";
      },
    },
    {
      title: "Status Bayar Progresif",
      dataIndex: "bill_progressive_status",
      key: "bill_progressive_status",
      width: 100,
    },
    {
      title: "Tgl Pelunasan",
      dataIndex: "bill_progressive_detail",
      key: "bill_progressive_detail",
      width: 80,
      render: (value) => {
        if (!value.qris_created_time) return "";
        return dayjs(value.qris_paid_time).format("YYYY-MM-DD HH:mm") || dayjs(value.qris_created_time).format("YYYY-MM-DD HH:mm") || "";
      },
    },
    {
      title: "Status BBN",
      dataIndex: "transfer_title_status",
      key: "transfer_title_status",
      width: 90,
    },
  ];

  generateFileCsv = React.createRef();
  constructor(props) {
    super(props);

    const { match } = this.props;
    const code_svb = match.params.code_svb;

    this.initState = {
      code_svb: code_svb,
      processing: false,
      processingFetchTableData: false,
      pageSize: 100,

      dataOrder: [],
      filterType: "ENGINE_NUMBER",
      filterEngineNumber: "",
      filterStatusBbn: "",
      filterDealer: "",
      filterDate: "",
      filterStatusProgressive: "PENDING",
      filterBillStatus: "",
      filterBillInvoice: "",

      loadingButton: false,
      tableSelectedRowKeys: [],
      dataExport: [],
      rowDetailOrder: [],
      showModalDetailOrder: false,
      showModalPaymentProgressive: false,
    };

    this.state = { ...this.initState };
  }

  handleToggleColumn = (category) => {
    this.setState((prevState) => ({
      [`show${category.charAt(0).toUpperCase() + category.slice(1)}`]: !prevState[`show${category.charAt(0).toUpperCase() + category.slice(1)}`],
    }));
  };

  tableGetVissibleColoumns = () => {
    const activeKeys = [];

    return this.tableColumn.filter((col) => {
      // tampilkan semua kolom kecuali yang termasuk kategori dan sedang di-hide
      return !Object.values(this.columnGroups).some((group) => group.includes(col.key)) || activeKeys.includes(col.key);
    });
  };

  tableGetVisibleColumnsWidth = () => {
    const visibleColumns = this.tableColumn;
    return visibleColumns.reduce((total, col) => {
      return total + (col.width || 120); // fallback default width
    }, 0);
  };

  copyToClipboard = async (data) => {
    await navigator.clipboard.writeText(data);
  };

  handleFieldChange = (field, value) => {
    this.setState({ [field]: value });

    if (field === "filterType") {
      this.setState({ filterEngineNumber: "" });
    }
  };

  changeFilterDate = (date, dateString) => {
    this.setState({
      filterDate: dateString,
    });
  };

  closeModalDetailOrder = (data) => {
    this.setState({
      showModalDetailOrder: false,
    });
  };

  showDetail = (data) => {
    // console.log(data);
    this.setState({
      rowDetailOrder: data,
      showModalDetailOrder: true,
    });
  };

  closeModalPaymentProgressive = () => {
    this.setState({
      showModalPaymentProgressive: false,
    });
  };

  showModalProgressive = (data) => {
    // console.log(data);
    this.setState({
      rowDetailOrder: data,
      showModalPaymentProgressive: true,
    });
  };

  fetchDataOrder = async () => {
    try {
      const filter = this.state;

      if (!filter.filterEngineNumber) {
        if (!filter.filterStatusBbn) {
          throw new Error("Status is Required");
        } else {
          if (!filter.filterDate && !filter.filterEngineNumber && filter.filterStatusBbn === "GENERATED") {
            throw new Error("Date is Required");
          }
        }
      }

      this.setState({
        processingFetchTableData: true,
        loadingButton: true,
      });

      const params = { notice_uploaded: true };

      params.service_bureau_code = this.state.code_svb;
      if (filter.filterEngineNumber !== "") {
        params.vehicle_engine_number = filter.filterEngineNumber;
      } else {
        if (filter.filterStatusBbn !== "") {
          params.transfer_title_status = filter.filterStatusBbn;
        }
        if (filter.filterDealer !== "") {
          params.dealer_code = filter.filterDealer;
        }

        if (filter.filterDate !== "") {
          params.date_start = dayjs(filter.filterDate).clone().startOf("month").format("YYYY-MM-DD");
          params.date_end = dayjs(filter.filterDate).clone().endOf("month").format("YYYY-MM-DD");
        }

        if (filter.filterStatusProgressive) {
          params.bill_progressive_status = filter.filterStatusProgressive;
        }
      }

      // console.log("params", params);
      otodisService.setToken(this.token);
      const dataOrder = await otodisService.getAssignedOrder(params);
      // console.log(dataOrder.data.success.data);

      this.setState({
        dataOrder: dataOrder.data.success.data,
        processingFetchTableData: false,
        loadingButton: false,
        tableSelectedRowKeys: [],
      });
    } catch (error) {
      this.setState({
        dataOrder: [],
        processingFetchTableData: false,
        loadingButton: false,
        tableSelectedRowKeys: [],
      });
      Modal.error({
        title: "Validation Error",
        content: error.message,
      });
      return false;
    }
  };

  onClickFilter = async () => {
    await this.fetchDataOrder();
  };

  onClickExport = async () => {
    const selectedRows = this.state.tableSelectedRowKeys;
    if (!selectedRows || selectedRows.length === 0) {
      Modal.error({
        title: "Validation Error",
        content: "Tidak Ada Data yang Dipilih",
      });
      return;
    }

    const headers = this.tableColumn.map((col) => col.title);
    const rows = [];

    selectedRows.forEach((row) => {
      const rowData = this.tableColumn.map((col) => {
        const dataIndex = col.dataIndex;
        const render = col.render;
        let value;

        if (dataIndex === "order_code") {
          value = row.order_code;
        } else if (dataIndex === "vehicle_engine_number") {
          value = row.vehicle_engine_number;
        } else if (dataIndex === "vehicle_registration_certificate_entry_date") {
          value = `IN: ${row.vehicle_registration_certificate_entry_date?.slice(0, -5) || ""} - OUT: ${row.vehicle_registration_certificate_submission_date?.slice(0, -5) || ""}`;
        } else if (dataIndex === "vehicle_certificate_of_ownership_entry_date") {
          value = `IN: ${row.vehicle_certificate_of_ownership_entry_date?.slice(0, -5) || ""} - OUT: ${row.vehicle_certificate_of_ownership_submission_date?.slice(0, -5) || ""}`;
        } else {
          value = dataIndex
            ? dataIndex
                .toString()
                .split(".")
                .reduce((acc, curr) => (acc ? acc[curr] : undefined), row)
            : undefined;

          if (render && typeof render === "function") {
            try {
              value = render(value, row);
              if (typeof value === "object" && value !== null && !Array.isArray(value)) {
                value = "";
              }
            } catch (err) {
              value = "";
            }
          }
        }

        return value ?? "";
      });

      rows.push(rowData);
    });

    console.log("headers", headers);
    console.log("rows", rows);

    const dataParsed = [headers, ...rows];

    this.setState({ loadingButton: true });

    try {
      await this.setState({
        dataExport: dataParsed,
      });

      this.generateFileCsv.current.link.click();

      this.setState({
        loadingButton: false,
      });
    } catch (error) {
      Modal.error({
        title: "Process Error",
        content: error.message,
      });
    }
  };

  handlePaymentUpdate = (updateRow) => {
    const updateListOrder = this.state.dataOrder.map((item) => {
      if (item.order_code === updateRow.order_code) {
        // console.log("NEW", item.order_code, item.progressive_payment_status, item.progressive_payment_detail);
        return {
          ...item,
          ...updateRow,
        };
      }
      return item;
    });

    this.setState({
      rowDetailOrder: updateRow,
      dataOrder: updateListOrder,
    });
  };

  renderToggleSwitch = (key, label, stateKey) => {
    return (
      <div>
        <Switch className="custom-switch" checked={this.state[stateKey]} onChange={() => this.handleToggleColumn(key)} checkedChildren={`Tampil ${label}`} unCheckedChildren={`Tidak Tampil ${label}`} />
      </div>
    );
  };

  render() {
    const rowTableSelection = {
      onChange: (selectedRowKeys, selectedRows) => {
        this.setState({
          tableSelectedRowKeys: selectedRows,
        });
      },
    };
    return (
      <React.Fragment>
        <MainLayout defaultOpenKeys={["2monitoringdata"]} defaultSelectedKeys={["4monitoringprogresif"]}>
          <div style={{ padding: 10, margin: 10, background: "#FFF" }}>
            <strong style={{ float: "right" }}>Monitoring Progresif</strong>
            <Form name="form-filter" layout="vertical" style={{ padding: 8 }}>
              <Row>
                <Col style={{ paddingLeft: 2, paddingRight: 2, minWidth: 150 }}>
                  <Form.Item label="Cari Menggunakan">
                    <Select value={this.state.filterType} onChange={(value) => this.handleFieldChange("filterType", value)} placeholder="Select Type Filter">
                      <Select.Option key="ENGINE_NUMBER">Nomor Mesin</Select.Option>
                      <Select.Option key="CUSTOM_FILTER">Custom Filter</Select.Option>
                    </Select>
                  </Form.Item>
                </Col>
                {this.state.filterType === "ENGINE_NUMBER" && (
                  <Col style={{ paddingLeft: 2, paddingRight: 2, minWidth: 150 }}>
                    <Form.Item label="Nomor Mesin">
                      <Input value={this.state.filterEngineNumber} onChange={(event) => this.handleFieldChange("filterEngineNumber", event.target.value)} />
                    </Form.Item>
                  </Col>
                )}
                {this.state.filterType === "CUSTOM_FILTER" && (
                  <React.Fragment>
                    <Col style={{ paddingLeft: 2, paddingRight: 2, minWidth: 150 }}>
                      <Form.Item label="Status BBN">
                        <Select value={this.state.filterStatusBbn} onChange={(value) => this.handleFieldChange("filterStatusBbn", value)} placeholder="Pilih Status">
                          <Select.Option key="UPLOADED" value="UPLOADED">
                            BELUM LUNAS
                          </Select.Option>
                          <Select.Option key="PAID" value="GENERATED">
                            SUDAH LUNAS
                          </Select.Option>
                        </Select>
                      </Form.Item>
                    </Col>

                    <Col style={{ paddingLeft: 2, paddingRight: 2, minWidth: 300 }}>
                      <SelectDealer value={this.state.filterDealer} onChangeValue={(value) => this.handleFieldChange("filterDealer", value)} />
                    </Col>

                    <Col style={{ paddingLeft: 2, paddingRight: 2, minWidth: 150 }}>
                      <Form.Item label="Tanggal Order">
                        <DatePicker onChange={this.changeFilterDate} picker="month" />
                      </Form.Item>
                    </Col>

                    <Col style={{ paddingLeft: 2, paddingRight: 2, minWidth: 150 }}>
                      <SelectStatusProgressive value={this.state.filterStatusProgressive} onChangeValue={(value) => this.handleFieldChange("filterStatusProgressive", value)} />
                    </Col>
                  </React.Fragment>
                )}
                <Col style={{ paddingLeft: 2, paddingRight: 2 }}>
                  <Form.Item label="&nbsp;">
                    <Space.Compact style={{ width: "100%" }}>
                      <Button onClick={this.onClickFilter} type="primary" icon={<SearchOutlined />} title="filter" style={{ minWidth: "50%", background: "#1784b8", borderColor: "#1784b8" }} loading={this.state.loadingButton}>
                        Filter
                      </Button>
                      &nbsp;
                      <Button onClick={this.onClickExport} type="primary" icon={<ExportOutlined />} title="export excel" style={{ minWidth: "50%", background: "#17a2b8", borderColor: "#17a2b8" }} loading={this.state.loadingButton}>
                        Export
                      </Button>
                    </Space.Compact>
                  </Form.Item>
                </Col>
              </Row>
            </Form>

            <CSVLink data={this.state.dataExport} filename="data-order.csv" ref={this.generateFileCsv} target="_blank" style={{ display: "none" }}>
              Export
            </CSVLink>

            <Table
              rowSelection={rowTableSelection}
              scroll={{ x: this.tableGetVisibleColumnsWidth() }}
              rowKey={"order_code"}
              size={"small"}
              loading={this.state.processingFetchTableData}
              columns={this.tableColumn}
              dataSource={this.state.dataOrder}
              pagination={{ pageSize: this.state.pageSize }}
              onChange={this.onChangeTable}
              className="text-uppercase"
              style={{ fontSize: "10%" }}
            />
          </div>
          <ModalDetailBBN kodeOrder={"aaaa"} dataOrder={this.state.rowDetailOrder} visible={this.state.showModalDetailOrder} onClose={this.closeModalDetailOrder} />
          <ModalPaymentProgressive kodeOrder={"aaaa"} dataOrder={this.state.rowDetailOrder} visible={this.state.showModalPaymentProgressive} onClose={this.closeModalPaymentProgressive} onPaymentUpdate={this.handlePaymentUpdate} />
        </MainLayout>
      </React.Fragment>
    );
  }
}

export default withAuth(MonitoringProgressive);
